// Modules
import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation, useParams, Redirect } from 'react-router-dom';

import Layout from 'Components/layout/Layout.jsx';
import BCrumb from 'Components/Bcrumb/BCrumb.jsx';
import Headline from 'Components/headline/Headline.jsx';
import ContactCard from 'Components/contactCard/ContactCard.jsx';
import SelfServiceOption from 'Components/selfServiceOption/SelfServiceOption.jsx';
import { setSelectedTopicId } from 'Store/reducer/selectedTopic';
import { setSelectedContactId } from 'Store/reducer/selectedContactPage';

import { selectSelectedTopic, selectContactPage } from 'Store/selectors';
// styles
import { useGetTopicQuery } from 'Services/api';

import { useAppDispatch } from 'Store';
import { ROUTE_HOME } from 'Constants/routes';
import Loader from '../../components/loading/Loader';
import { sendAnalyticEvent } from '../../utils/analytics';

const GetSupport = () => {
    // Hooks
    const dispatch = useAppDispatch();
    const location = useLocation();

    const { suggestedTopicId } = useParams();

    const { data: pages, isLoading: loadingPages, isFetching } = useGetTopicQuery();

    const topicID = useSelector(selectSelectedTopic);
    const selectedContactID = useSelector(selectContactPage);
    const [selfService, setSelfService] = useState(false);
    const [selfServiceButton, setSelfServiceButton] = useState(false);
    const [listSelectedtopics, setListSelectedtopics] = useState([]);
    const [selectedContactPage, setSelectedContactPage] = useState({});
    const [redirect, setRedirect] = useState(false);

    const setBySubtopicId = () => {
        const foundTopicID = pages.topics.find((topic) =>
            topic.topics.some((subtopic) => subtopic.id === suggestedTopicId),
        )?.id;

        dispatch(setSelectedTopicId({ topicId: foundTopicID }));
        dispatch(setSelectedContactId({ contactId: suggestedTopicId }));

        setListSelectedtopics(() => pages.topics?.find(({ id }) => id === foundTopicID)?.topics);
        setSelectedContactPage(listSelectedtopics?.find(({ id }) => id === suggestedTopicId));
    };

    useEffect(() => {
        if (pages) {
            setRedirect(
                !pages.topics.find((topic) =>
                    topic.topics.some((subtopic) => subtopic.id === suggestedTopicId),
                )?.id,
            );
        }

        if (pages && pages.topics.length && topicID) {
            setListSelectedtopics(() => pages.topics?.find(({ id }) => id === topicID)?.topics);
            setSelectedContactPage(listSelectedtopics?.find(({ id }) => id === selectedContactID));
        }

        if (pages && pages.topics.length && !topicID) {
            setBySubtopicId();
        }

        if (selectedContactPage) {
            setSelfService(() => !!selectedContactPage.recommendation);
        }

        if (selfService) {
            setSelfServiceButton(() => !!selectedContactPage.recommendation.callToActionText);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pages, selectedContactPage, selfService, selfServiceButton, isFetching]);

    useEffect(() => {
        const currentPath = location.pathname + location.search;
        sendAnalyticEvent({ category: 'pageview', pagePath: currentPath });
    }, [location]);

    return (
        <Layout>
            <BCrumb />
            {selectedContactPage ? (
                <Fragment>
                    <Loader isLoading={loadingPages}>
                        <Headline
                            title={selectedContactPage.headline}
                            description={selectedContactPage.body}
                        />
                    </Loader>
                    {/* recommendation Option */}
                    <Loader isLoading={loadingPages} loaderHeight="270px">
                        {selectedContactPage.recommendation && (
                            <Fragment key={selectedContactPage.recommendation.id}>
                                <SelfServiceOption
                                    headline={selectedContactPage.recommendation.headline}
                                    content={selectedContactPage.recommendation.body}
                                    buttonLabel={
                                        selectedContactPage.recommendation.callToActionText
                                    }
                                    buttonLink={selectedContactPage.recommendation.callToActionUrl}
                                    imgCMS={selectedContactPage.recommendation.image}
                                />
                            </Fragment>
                        )}
                    </Loader>
                    <Loader isLoading={loadingPages} loaderHeight="350px">
                        {selectedContactPage.contactMethods
                            ? selectedContactPage.contactMethods.map((item, index) => (
                                  <Fragment key={item.id}>
                                      <ContactCard
                                          id={item.id}
                                          cardTitle={item.titleContact}
                                          cardContent={item.bodyContact}
                                          contactType={item.type}
                                          contactLabel={item.buttonLabel}
                                          index={index}
                                          phoneNumber={item.phoneNumber}
                                          phoneNumbers={item.phoneNumbers}
                                          imgCMS={item.image}
                                          recommended={selfService}
                                          recommendedButtonExists={selfServiceButton}
                                          disclaimer={item.disclaimer}
                                          buttonLink={item.callToActionUrl}
                                      />
                                  </Fragment>
                              ))
                            : null}
                    </Loader>
                </Fragment>
            ) : (
                redirect && <Redirect to={ROUTE_HOME} />
            )}
        </Layout>
    );
};

GetSupport.propTypes = {
    location: PropTypes.object,
};

export default GetSupport;
